<template>
  <form @submit.prevent="store_sale_invoice({ load_status: null})">
    <div class="tw-bg-white tw-border tw-border-[#E2E2E2] tw-py-8 tw-px-4 md:tw-p-8 tw-rounded-[12px]">
      <h3 class="tw-mb-5 tw-text-base tw-text-static-headerGray">اطلاعات پایه</h3>

      <div class="tw-block md:tw-grid md:tw-grid-cols-10 tw-gap-3 tw-mb-8">
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <base-date-picker title="تاریخ فاکتور"
                            v-model="invoice_date"
                            :errorMessage="errors.invoice_date"
                            class="tw-mb-6" />
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <base-date-picker title="تاریخ بارگیری"
                            placeholder="تاریخ بارگیری (اختیاری)"
                            v-model="date_loaded"
                            :errorMessage="errors.date_loaded"
                            class="tw-mb-6" />
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <plate default_letter=""
                 size="sm"
                 :required="false"
                 :errorMessage="{
                    letter: errors.plate,
                  }"
                 v-model:plate="plate"
                 class="tw-mb-6" />
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <select-users title="مشتری"
                        placeholder="انتخاب مشتری"
                        icon="person"
                        :errorMessage="errors.user_id"
                        v-model="user_id" />
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <base-select title="محصول"
                       placeholder="انتخاب محصول"
                       :float-title="true"
                       :search_able="true"
                       :search_in_front="true"
                       :loading="loadingGetKalas"
                       v-model="kala_id"
                       :options="kalas"
                       :errorMessage="errors.kala_id"
                       icon="category"/>
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <input-ayandeh
            v-model:value="number_bar"
            icon-on-input="barcode"
            :errorMessage="errors.number_bar"
            placeholder="شماره را وارد کنید (اختیاری)"
            float-label="شماره بارنامه" />
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <base-select title="واحد ارزی"
                       :float-title="true"
                       :loading="false"
                       v-model="price_unit"
                       :options="priceUnits"
                       :errorMessage="errors.price_unit"
                       icon="currency-exchange" />
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <input-ayandeh
            v-model:value="price_arz"
            placeholder="به ریال"
            :number-format="true"
            icon-on-input="swap-vertical-circle"
            :errorMessage="errors.price_arz"
            float-label="نرخ ارز" />
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <input-ayandeh
            v-model:value="price_per_ton_arz"
            :placeholder="!!price_unit ?  'به ' + priceUnits.find(x => x.value === price_unit).label : 'فی هر تن'"
            :number-format="true"
            icon-on-input="universal-currency"
            :errorMessage="errors.price_per_ton_arz"
            float-label="فی هر تن" />
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <input-ayandeh
            v-model:value="tonage"
            placeholder="تن"
            icon-on-input="weight"
            :errorMessage="errors.tonage"
            float-label="میزان (تن)" />
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <base-select title="انبار"
                       placeholder="انبار را انتخاب کنید"
                       :float-title="true"
                       :loading="getDataLoading"
                       v-model="origin_warehouse_id"
                       :options="dataStoreOrder?.warehouses"
                       :errorMessage="errors.origin_warehouse_id"
                       icon="warehouse"/>
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <base-select title="محل تخلیه"
                       placeholder="انتخاب محل تخلیه (اختیاری)"
                       :search_able="true"
                       :search_in_front="false"
                       :float-title="true"
                       :loading="loadingGetCities"
                       v-model="city_id"
                       :options="cities"
                       :can-load-more="hasNextPageCities"
                       @loadMore="loadMoreCities"
                       icon="distance"/>
        </div>
        <div class="tw-w-full md:tw-col-span-6 tw-mb-6">
          <input-ayandeh
            v-model:value="address"
            :errorMessage="errors.address"
            placeholder="وارد کردن آدرس (اختیاری)"
            icon-on-input="distance"
            float-label="آدرس" />
        </div>


        <div class="tw-w-full md:tw-col-span-12 tw-mb-6">
          <BaseTextArea v-model="description"
                        icon="description"
                        placeholder="نوشتن توضیحات (اختیاری)"
                        :errors-message="errors.description" />
        </div>
      </div>
    </div>

    <new-manage-other-snd ref="other_sanads_manage"
                          v-model="other_sanads"
                          v-model:validated="other_sanads_validated" />

    <div class="tw-fixed tw-text-primary-500 tw-bottom-0 tw-left-0 tw-w-full tw-px-4 tw-pt-6 tw-pb-5 tw-bg-white tw-flex tw-justify-between tw-border-t tw-border-static-inputBorder2"
         :class="[store.state.sidebarVisible && 'md:tw-pr-sidebar-width' ]">
      <button type="button" class="tw-bg-white !tw-font-bold !tw-text-primary-500" @click="addOtherSnd">
        <base-icon icon="add-circle" class="tw-ml-3 tw-align-middle" />
        افزودن سند حسابداری
      </button>

      <more-btn color="blue-dark"
                :loading="loading_store_sale_invoice"
                :disabled="!formValidated || loading_store_sale_invoice"
                label="ذخیره فاکتور و">
        <template #options>
          <more-btn-options text="ثبت بارگیری" @click="store_sale_invoice({ load_status: 'loaded'})"/>
          <more-btn-options text="ثبت بارگیری و تخلیه" @click="store_sale_invoice({ load_status: 'discharged'})"/>
        </template>
      </more-btn>
    </div>
  </form>
</template>

<script setup>

import {useStore} from 'vuex'
import {onMounted, ref, nextTick, getCurrentInstance, computed, watch} from "vue";
import BaseSelect from "@/components/base/select/BaseSelect.vue";
import { priceUnits } from '@/services/more/ConstVar'
import InputAyandeh from "@/components/inputs/InputAyandeh.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";
import SelectUsers from "@/components/base/select/SelectUsers.vue";
import NewManageOtherSnd from "@/views/sanads_other/NewManageOtherSnd.vue";
import {useForm, useField} from "vee-validate";
import * as yup from 'yup'
import { useRouter } from "vue-router";
import BaseDatePicker from "@/components/base/select/BaseDatePicker.vue";
import Plate from "@/components/partial/Plate.vue";
import MoreBtn from "@/components/base/btn/MoreBtn.vue";
import MoreBtnOptions from "@/components/base/btn/MoreBtnOptions.vue";
import { apiStoreSaleInvoice } from "@/services/invoice/Invoice";
import { apiGetKalas } from "@/services/fm/Accounting";
import {getCities, cities, hasNextPageCities, loadingGetCities, loadMoreCities} from "@/services/city/Cities";
import BaseTextArea from "@/components/base/input/BaseTextArea.vue";



const other_sanads_manage = ref(null) // ref
const other_sanads = ref([])
const other_sanads_validated = ref(true)
const loading_store_sale_invoice = ref(false)
const kalas = ref([])
const loadingGetKalas = ref(false)


const { proxy } = getCurrentInstance()
const router = useRouter()
const store = useStore()



const { handleSubmit, errors, meta, validate} = useForm({
  validationSchema: {
    invoice_date: yup.string().required('تاریخ فاکتور الزامی است'),
    date_loaded: yup.string().required('تاریخ بارگیری الزامی است'),
    plate: yup
      .object()
      .shape({
        letter: yup.string().nullable(),
        two_digits: yup.string().nullable(),
        three_digits: yup.string().nullable(),
        number_base: yup.string().nullable(),
      })
      .test(
        'plate-all-or-nothing',
        'در صورت وارد کردن پلاک، تکمیل همه بخش‌های پلاک الزامی است',
        function (value) {
          if (!value) return true

          const { letter, two_digits, three_digits, number_base } = value

          const fields = [letter, two_digits, three_digits, number_base]
          const filled = fields.filter(v => v && String(v).trim() !== '')
          const empty = fields.filter(v => !v || String(v).trim() === '')

          // یا همش خالیه، یا همش پر
          return filled.length === 0 || empty.length === 0
        }
      ),
    user_id: yup.string().required('فیلد مشتری الزامی است'),
    kala_id: yup.string().required('محصول الزامی است'),
    number_bar: yup.string().nullable('محصول الزامی است'),
    price_unit: yup.string().required('واحد ارز الزامی است'),
    price_arz: yup.string().required('نرخ ارز الزامی است'),
    price_per_ton_arz: yup.string().required('فی هر تن الزامی است'),
    tonage: yup.string().required('میزان خرید الزامی است'),
    origin_warehouse_id: yup.string().required('انبار الزامی است'),
    description: yup.string().nullable('توضیحات اختیاری است'),
    city_id: yup.string().nullable('محل تخلیه اختیاری است'),
    address: yup.string().nullable('آدرس اختیاری است'),
  },
})

const { value: invoice_date } = useField('invoice_date')
const { value: date_loaded } = useField('date_loaded')
const { value: plate } = useField('plate')
const { value: user_id } = useField('user_id')
const { value: kala_id } = useField('kala_id')
const { value: number_bar } = useField('number_bar')
const { value: price_unit } = useField('price_unit')
const { value: price_arz } = useField('price_arz')
const { value: price_per_ton_arz } = useField('price_per_ton_arz')
const { value: description } = useField('description')
const { value: address } = useField('address')
const { value: city_id } = useField('city_id')
const { value: tonage } = useField('tonage')
const { value: origin_warehouse_id } = useField('origin_warehouse_id')

onMounted(() => {
  if(!kalas.value.length) {
    get_kalas()
  }
  getCities()
})

const props = defineProps({
  getDataLoading: {
    type: Boolean,
    default: false
  },
  dataStoreOrder: {
    type: Object,
    default: () => {}
  }
})

async  function addOtherSnd() {
  await nextTick()
  other_sanads_manage.value.add_sanad()
}


async function get_kalas() {

  loadingGetKalas.value = true

  try {
    const response = await apiGetKalas()
    if(!response) return
    if(response?.data?.message) proxy.$toast(response?.data?.message, 'error')

    kalas.value = response.data.kalas

  } catch (error) {} finally {
    loadingGetKalas.value = false
  }
}


async function store_sale_invoice(options = {}) {

  await validate()
  if(!options.load_status) return

  if(meta.value.valid === false) {
    proxy.$toast('لطفا موارد خواسته شده را با دقت پر کنید.', "error")
    return false
  }

  loading_store_sale_invoice.value = true
  var data = {
    ...options,
    user_id: user_id.value,
    invoice_date: invoice_date.value,
    date_loaded: date_loaded.value,
    tonage: tonage.value,
    kala_id: kala_id.value,
    address: address.value,
    city_id: city_id.value,
    description: description.value,
    origin_warehouse_id: origin_warehouse_id.value,
    price_unit: price_unit.value,
    price_arz: price_arz.value,
    price_per_ton_arz: price_per_ton_arz.value,
    plate: plate.value,
    other_sanads: other_sanads.value.map(function(item) {
      const newItem = { ...item }
      newItem.bank_information_id = item.bank_information?.id
      delete newItem.bank_information

      return newItem
    }),
  }



  try {
    const response = await apiStoreSaleInvoice(data)
    if(!response) return

    if (response?.data.status === 'success') {
      router.replace({ name: 'NewOrdersList' })
    }
    proxy.$my_alert(response.data.message, response.data.status)

  } catch (error) {
    console.log(error)
  } finally {
    loading_store_sale_invoice.value = false
  }

}


const formValidated = computed(() => {
  return meta.value.valid && other_sanads_validated.value
})

</script>


<style scoped>

</style>
